module.exports = __webpack_public_path__ + "img/list-view.6cde95a7.svg";